"use strict"

angular.module("preventUnsavedChanges")
.service("PreventUnsavedChangesService", function(ModalService) {
    this.openModal = function(unsavedMessage) {
        return ModalService.showModal({
            templateUrl: require("./prevent-unsaved-changes.modal.html"),
            controllerAs: "unsavedChangesCtrl",
            controller: "UnsavedChangesModalController",
            inputs: {
                $attrs: {
                    message: unsavedMessage
                }
            }
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/prevent-unsaved-changes/prevent-unsaved-changes.service.js
// module id = 338
// module chunks = 0